import packagesService from '@/modules/payments/services/packagesService';

const PAGE_SIZE = 25;

const state = {
  packages: [],
  loading: false,
  completed: false,
  currentPageIndex: 1,
};

const getters = {
  packages: (state) => state.packages,
  loading: (state) => state.loading,
  completed: (state) => state.completed,
  getPackageByUid: (state) => (uid) => state.packages.find((package_) => package_.id === uid),
};

const mutations = {
  setPackages(state, packages) {
    state.packages = packages;
  },
  appendPackages(state, packages) {
    state.packages = [...state.packages, ...packages];
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setCompleted(state, completed) {
    state.completed = completed;
  },
  increaseCurrentPageIndex(state) {
    state.currentPageIndex += 1;
  },
};

const actions = {
  async loadPackages({ commit, state }) {
    if (state.loading || state.completed) return;

    commit('setLoading', true);
    try {
      const packages = await packagesService.fetchPackages(1, PAGE_SIZE);
      commit('setPackages', packages);
      commit('setCompleted', packages.length < PAGE_SIZE);
    } catch (error) {
      console.error('Error fetching packages:', error);
    } finally {
      commit('setLoading', false);
    }
  },

  async loadMorePackages({ commit, state }) {
    if (state.loading || state.completed) return;

    commit('setLoading', true);
    try {
      const packages = await packagesService.fetchPackages(state.currentPageIndex, PAGE_SIZE);
      commit('appendPackages', packages);
      commit('increaseCurrentPageIndex');
      commit('setCompleted', packages.length < PAGE_SIZE);
    } finally {
      commit('setLoading', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
